import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';
import { zodOptionalId } from 'routes/routeUtils';
import { z } from 'zod';

export const onboardingJoinPharmacyRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/join_pharmacy',
  validateSearch: z.object({
    pharmacy_id: zodOptionalId,
  }),
}).lazy(() => import('pages/shared/Onboarding/JoinPharmacy/JoinPharmacyPage').then((d) => d.Route));
